import moment from "moment";
import { BaseModel } from "sjs-base-model";

export default class NuovoAppuntamentoFormModel extends BaseModel {
    public readonly idAppointment?: number = 0;
    public readonly oggetto: string = "";
    public readonly luogo: string = "";
    public readonly data: string = "";
    public readonly oraInizio: string = "";
    public readonly oraFine: string = "";
    public readonly testo: string = "";

    constructor(data: Partial<NuovoAppuntamentoFormModel>) {
        super();

        const now = moment();
        this.data = now.format("DD/MM/YYYY");
        this.oraInizio = now.format("HH:mm");
        this.oraFine = now.add("hours", 1).format("HH:mm");
        this.update(data);
    }
}
